import { clsx } from "clsx";
import type { LucideIcon } from "lucide-react";

type IconActionButtonProps = {
  icon: LucideIcon;
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  tone?: "default" | "accent" | "danger";
};

export function IconActionButton({
  icon: Icon,
  label,
  onClick,
  disabled,
  tone = "default",
}: IconActionButtonProps) {
  return (
    <div className="tooltip-group">
      <button
        type="button"
        className={clsx(
          "icon-action",
          tone === "accent" &&
            "border-lime-300/30 text-lime-200 hover:border-lime-300/50 hover:bg-lime-300/10",
          tone === "danger" &&
            "border-red-400/25 text-red-200 hover:border-red-300/40 hover:bg-red-400/10",
          disabled && "cursor-not-allowed opacity-50"
        )}
        disabled={disabled}
        onClick={onClick}
      >
        <span className="sr-only">{label}</span>
        <Icon className="h-4 w-4" />
      </button>
      <span className="tooltip-bubble">{label}</span>
    </div>
  );
}
